import {Box, Divider, Stack, Typography} from "@mui/material";
import {IconBrain, IconCheckbox, IconHeadphones, IconPhoneCall} from "@tabler/icons-react";
import {AgentAnimation} from "../../../components/lottie-animations/AgentAnimation";


export const HowItWorks = () => {

  return (
    <Stack
      direction={"row"} gap={{xs: 2, md: 6}}
      useFlexGap flexWrap={"wrap"}
      justifyContent={"space-evenly"}
      sx={{px: {xs: 2, md: 6}, py: {xs: 4, md: 10}}}
    >
      <Stack direction={"column"} alignItems={"center"}>
        <Stack direction={"column"} gap={{xs: 2, md: 4}} maxWidth={"sm"}>
          <Typography fontSize={{xs: "1.2em", md: "1.6em"}} fontWeight={600} color={"secondary"}
                      sx={{width: "100%"}} align={"center"}>
            AI That Works Like Your Best Agent—Instantly
          </Typography>
          <Divider sx={{width: "90%", mx: "auto"}} />
          <Stack direction={"row"} gap={{xs: 2, md: 4}} alignItems={"center"}>
            <Box sx={{color: "primary.dark"}}>
              <IconPhoneCall size={30} />
            </Box>
            <Box>

              <Typography fontWeight={600} fontSize={{xs: "1em", md: "1.2em"}}>Instant Call Routing</Typography>
              <Typography fontWeight={300} fontSize={{xs: "0.9em", md: "1em" }}>
                {"Your AI greets callers in <1 second—no hold times, no frustration."}
              </Typography>
            </Box>
          </Stack>
          <Stack direction={"row"} gap={{xs: 2, md: 4}} alignItems={"center"}>
            <Box sx={{color: "primary.dark"}}>
              <IconBrain size={30} />
            </Box>
            <Box>
              <Typography fontWeight={600} fontSize={{xs: "1em", md: "1.2em"}}>Smart Intent Detection</Typography>
              <Typography fontWeight={300} fontSize={{xs: "0.9em", md: "1em" }}>
                {"NLP understands 100+ customer needs (billing, support, returns, etc.)."}
              </Typography>
            </Box>
          </Stack>
          <Stack direction={"row"} gap={{xs: 2, md: 4}} alignItems={"center"}>
            <Box sx={{color: "primary.dark"}}>
              <IconCheckbox size={30} />
            </Box>
            <Box>
              <Typography fontWeight={600} fontSize={{xs: "1em", md: "1.2em"}}>Automated Resolution</Typography>
              <Typography fontWeight={300} fontSize={{xs: "0.9em", md: "1em" }}>
                {"Handles 60-70% of FAQs (refunds, hours, tracking) without human help."}
              </Typography>
            </Box>
          </Stack>
          <Stack direction={"row"} gap={{xs: 2, md: 4}} alignItems={"center"}>
            <Box sx={{color: "primary.dark"}}>
              <IconHeadphones size={30} />
            </Box>
            <Box>
              <Typography fontWeight={600} fontSize={{xs: "1em", md: "1.2em"}}>Seamless Human Handoff</Typography>
              <Typography fontWeight={300} fontSize={{xs: "0.9em", md: "1em" }}>
                {"Escalates complex issues with full context to agents."}
              </Typography>
            </Box>
          </Stack>
        </Stack>
      </Stack>
      <Stack  maxWidth={"460px"} alignItems={"center"} justifyContent={"center"} sx={{flex: 1}}>
       <AgentAnimation open width={320} height={400} />
      </Stack>
    </Stack>
  )
}